export default __webpack_public_path__ + "static/media/about-background.033dcb28.png";